import { APP_BASE_HREF } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../../environments/environment';
import { FooterComponent } from '../components/footer/footer.component';
import { HeaderComponent } from '../components/header/header.component';
import { FullLayoutComponent } from '../components/layouts/full-layout/full-layout.component';
import { NavigationComponent } from '../components/navigation/navigation.component';
import { AppComponent } from '../components/pages/app/app.component';
import { CoreModule } from '../core/modules/core.module';
import { SharedModule } from '../shared/modules/shared.module';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent, FullLayoutComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CoreModule,
    HeaderComponent,
    NavigationComponent,
    SharedModule,
    FooterComponent
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: environment.appBase
    }
  ]
})
export class AppModule {}
